/**
 * Last-modified dates for non-article pages (ISO 8601), keyed by route path.
 * Single source for the dateModified value emitted in each page's WebPage node.
 */
export const pageDates: Record<string, string> = {
  "/services/partner-alignment": "2026-11-03",
  "/services/structure-and-performance-reset": "2026-11-03",
  "/": "2026-11-03",
  "/about": "2026-11-03",
  "/about/adam-ayoub": "2026-11-03",
  "/advisers": "2026-08-18",
  "/contact": "2026-11-03",
  "/decision-sprint": "2026-11-03",
  "/fractional-coo-australia": "2026-11-03",
  "/fractional-general-manager": "2026-11-03",
  "/fractional-coo-central-coast": "2026-08-28",
  "/fractional-coo-melbourne": "2026-08-28",
  "/fractional-coo-newcastle": "2026-08-28",
  "/fractional-coo-perth": "2026-08-28",
  "/fractional-coo-sydney": "2026-08-28",
  "/giving": "2026-08-18",
  "/how-we-work": "2026-08-28",
  "/insights": "2026-09-22",
  "/packages": "2026-11-03",
  "/privacy": "2026-08-18",
  "/scan": "2026-11-03",
  "/services": "2026-09-22",
  "/services/operating-system": "2026-11-03",
  "/services/team-structure": "2026-09-22",
  "/services/strategy-execution": "2026-09-22",
  "/services/performance-discipline": "2026-09-22",
  "/services/project-leadership": "2026-09-22",
  "/services/systems-improvement": "2026-09-22",
  "/specialisations": "2026-11-03",
  "/specialisations/pricing-and-revenue-management": "2026-11-03",
  "/specialisations/planning-budgeting-and-forecasting": "2026-11-03",
  "/specialisations/roles-targets-and-incentives": "2026-11-03",
  "/specialisations/project-and-commercial-control": "2026-11-03",
  "/specialisations/procurement-and-supplier-costs": "2026-11-03",
  "/specialisations/systems-selection-and-implementation": "2026-11-03",

  "/terms": "2026-08-18",
  "/tools": "2026-11-03",
  "/tools/cash-runway-calculator": "2026-10-30",
  "/tools/price-change-impact-calculator": "2026-10-30",
  "/tools/time-and-accountability-grid": "2026-10-30",
  "/tools/fractional-coo-cost-calculator": "2026-10-30",
  "/tools/revenue-leakage-check": "2026-10-30",
  "/tools/weekly-scorecard-builder": "2026-10-30",
  "/tools/partner-alignment-check": "2026-11-03",
};

/** Fallback for any page not yet listed above. */
export const SITE_LAST_MODIFIED = "2026-08-27";

export const pageModified = (path: string) => pageDates[path] ?? SITE_LAST_MODIFIED;
